import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  // スクロール検知
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      setIsScrolled(window.scrollY > 50);
    });
  }

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-md'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/0e64fe7d7ddf660e67742842ccecd709.png" alt="ロゴ" className="h-8 sm:h-10 w-auto" />
            <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 hidden sm:block">月間利益を増やす設計</h1>
          </div>
          <nav className="hidden md:flex items-center gap-6">
            <a href="#impact" className="text-sm font-medium text-gray-700 hover:text-[#1A3A52] transition-colors cursor-pointer">改善インパクト</a>
            <a href="#service" className="text-sm font-medium text-gray-700 hover:text-[#1A3A52] transition-colors cursor-pointer">提供内容</a>
            <a href="#price" className="text-sm font-medium text-gray-700 hover:text-[#1A3A52] transition-colors cursor-pointer">料金プラン</a>
          </nav>
          <div className="flex items-center">
            <a href="#contact" className="px-4 sm:px-6 py-2.5 sm:py-3 bg-[#1A3A52] text-white text-sm sm:text-base rounded-lg font-medium hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
              無料で利益改善シミュレーション
            </a>
          </div>
        </div>
      </header>

      {/* ファーストビュー */}
      <section className="relative pt-24 sm:pt-28 lg:pt-32 pb-12 sm:pb-16 lg:pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-transparent z-0"></div>
        <div className="absolute right-0 top-0 bottom-0 w-2/5 z-0 hidden lg:block">
          <img 
            src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/b1984d82d91936f764d60fa77947a9ce.webp" 
            alt="整体院受付" 
            className="w-full h-full object-cover object-center"
          />
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="max-w-2xl">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight mb-4 sm:mb-5">
              整体・整骨院・ジムの<br />
              月間利益を<span className="text-[#1A3A52]">＋30万〜50万円</span><br />
              改善する設計
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3 sm:mb-4">
              広告を増やさず、<br />
              今ある導線を整えるだけで<br />
              <strong>「予約数」と「利益」を安定させます。</strong>
            </p>

            <p className="text-xs sm:text-sm text-red-600 mb-6 sm:mb-8 lg:mb-10">※ 月商300万円以上／広告費月5万円以上の院・ジム向け</p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
              <a href="#contact" className="px-8 sm:px-10 lg:px-12 py-3.5 sm:py-4 lg:py-5 bg-[#1A3A52] text-white text-base sm:text-lg rounded-lg font-bold hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
                無料で利益改善シミュレーション
              </a>
              <p className="text-xs sm:text-sm text-gray-500">（営業なし／30分オンライン）</p>
            </div>

            {/* スクロール誘導 */}
            <div className="mt-8 sm:mt-10 flex flex-wrap gap-3 sm:gap-4">
              <a href="#impact" className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-[#1A3A52] transition-colors cursor-pointer">
                <i className="ri-arrow-down-s-line text-lg"></i>
                <span>改善インパクト</span>
              </a>
              <a href="#service" className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-[#1A3A52] transition-colors cursor-pointer">
                <i className="ri-arrow-down-s-line text-lg"></i>
                <span>提供内容</span>
              </a>
              <a href="#price" className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-[#1A3A52] transition-colors cursor-pointer">
                <i className="ri-arrow-down-s-line text-lg"></i>
                <span>料金プラン</span>
              </a>
            </div>
          </div>

          {/* FV画像追加（スマホ表示用） */}
          <div className="mt-8 sm:mt-10 lg:hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/d311d9dc8fc4a5c6c920f2a8a6d3b339.jpg"
              alt="改善の方針を見える化"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
            <p className="text-xs sm:text-sm text-gray-600 text-center mt-3">改善の方針を"見える化"して、最短で整えます</p>
          </div>
        </div>
      </section>

      {/* 問題提起 */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#F0F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">広告を出しているのに<br />なぜ利益が増えないのか？</h2>
          
          <div className="max-w-3xl mx-auto mb-10 sm:mb-12">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6 text-center">
              多くの院・ジムが<br />
              <strong>・広告</strong><strong>・LP</strong><strong>・予約ツール</strong><strong>・LINE</strong><br />
              を導入しています。
            </p>
            <p className="text-lg sm:text-xl font-bold text-gray-900 mb-4 text-center">しかし──</p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed text-center">
              それぞれが<span className="text-[#1A3A52] font-bold">分断されているため</span><br />
              <strong>「利益」に変換されていません。</strong>
            </p>
          </div>

          <div className="bg-[#FFF9E6] rounded-xl p-5 sm:p-6 text-center max-w-2xl mx-auto">
            <p className="text-base sm:text-lg text-gray-800 font-bold">問題は広告ではなく<br /><span className="text-[#1A3A52] text-xl sm:text-2xl">設計不足</span>です。</p>
          </div>

          {/* Before画像追加 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-10 sm:mt-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/db4eea0857db6c2475731b10f113c408.webp"
                alt="見づらいサイト"
                className="w-full h-auto rounded-2xl shadow-md"
              />
              <p className="text-xs sm:text-sm text-gray-600 mt-3"><strong>Before：</strong>見づらい</p>
            </div>
            <div>
              <img 
                src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/9b20c61ae08d5c5e54e43e78c4cf5441.webp"
                alt="行動できないサイト"
                className="w-full h-auto rounded-2xl shadow-md"
              />
              <p className="text-xs sm:text-sm text-gray-600 mt-3"><strong>Before：</strong>行動できない</p>
            </div>
          </div>
        </div>
      </section>

      {/* 数字で見る改善インパクト */}
      <section id="impact" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">たった月3名増えるだけで<br />利益は変わります</h2>
          
          <div className="max-w-3xl mx-auto">
            {/* LTV計算ボックス */}
            <div className="bg-[#E8F5F1] rounded-2xl p-6 sm:p-8 lg:p-10 mb-8 sm:mb-10 border-2 border-[#1A3A52]">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-5 sm:mb-6 text-center">例：</h3>
              <div className="space-y-3 sm:space-y-4 mb-6">
                <div className="flex items-center justify-between">
                  <span className="text-sm sm:text-base text-gray-700">平均単価：</span>
                  <span className="text-xl sm:text-2xl font-bold text-gray-900">6,000円</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm sm:text-base text-gray-700">平均来院回数：</span>
                  <span className="text-xl sm:text-2xl font-bold text-gray-900">5回</span>
                </div>
                <div className="border-t-2 border-[#1A3A52] pt-3">
                  <div className="flex items-center justify-between">
                    <span className="text-base sm:text-lg font-bold text-gray-900">顧客LTV：</span>
                    <span className="text-2xl sm:text-3xl font-bold text-[#1A3A52]">30,000円</span>
                  </div>
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4 bg-white rounded-xl p-4 sm:p-5">
                <div className="flex items-center justify-between">
                  <span className="text-sm sm:text-base font-medium text-gray-700">月3名増加 →</span>
                  <span className="text-xl sm:text-2xl font-bold text-[#1A3A52]">90,000円増</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm sm:text-base font-medium text-gray-700">月5名増加 →</span>
                  <span className="text-xl sm:text-2xl font-bold text-[#1A3A52]">150,000円増</span>
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                <strong className="text-lg sm:text-xl text-gray-900">広告費を増やさなくても<br />導線改善だけで十分可能です。</strong>
              </p>
            </div>

            {/* 診断画像追加 */}
            <div className="mt-8 sm:mt-10">
              <img 
                src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/b1506b0eebf8e6d79731e71500d0a348.webp"
                alt="改善点の整理"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
              <p className="text-xs sm:text-sm text-gray-600 text-center mt-3">改善点と優先順位を整理してから動くので、無駄が出ません</p>
            </div>
          </div>
        </div>
      </section>

      {/* サービスの本質 */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#F0F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">
            私たちは<br />
            <span className="text-[#1A3A52]">「制作会社」ではありません</span>
          </h2>
          
          <div className="max-w-3xl mx-auto mb-10 sm:mb-12">
            <p className="text-base sm:text-lg text-gray-700 text-center leading-relaxed mb-6 sm:mb-8">
              LPを作ることが目的ではありません。<br />
              広告を回すことが目的でもありません。
            </p>

            <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg mb-8 sm:mb-10">
              <p className="text-xl sm:text-2xl font-bold text-[#1A3A52] text-center mb-6">目的は<br />利益が増える構造を作ること。</p>
              
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-5 sm:mb-6 text-center">
                <strong>広告 → LP → 予約 → 来院 → 再来</strong><br />
                この流れを一気通貫で設計し
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
                <div className="bg-[#F0F7F4] rounded-xl p-4 sm:p-5 text-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#1A3A52] rounded-full mb-3 mx-auto">
                    <i className="ri-map-pin-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <p className="text-sm sm:text-base font-bold text-gray-900">どこで離脱しているか</p>
                </div>
                <div className="bg-[#F0F7F4] rounded-xl p-4 sm:p-5 text-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#1A3A52] rounded-full mb-3 mx-auto">
                    <i className="ri-tools-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <p className="text-sm sm:text-base font-bold text-gray-900">何を直せば増えるか</p>
                </div>
                <div className="bg-[#F0F7F4] rounded-xl p-4 sm:p-5 text-center">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#1A3A52] rounded-full mb-3 mx-auto">
                    <i className="ri-money-dollar-circle-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <p className="text-sm sm:text-base font-bold text-gray-900">どこが利益を削っているか</p>
                </div>
              </div>
            </div>

            <div className="text-center">
              <p className="text-lg sm:text-xl font-bold text-[#1A3A52]">を可視化します。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Before / After */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
            <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border border-gray-200">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-400 text-center mb-5 sm:mb-6">Before</h3>
              
              {/* Before画像追加 */}
              <div className="mb-5">
                <img 
                  src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/85ca7729aba5f9f7a2f1b4f538351626.webp"
                  alt="改善前のサイト"
                  className="w-full h-auto rounded-xl shadow-md"
                />
                <p className="text-xs text-gray-600 text-center mt-2">伝わらず離脱しやすい</p>
              </div>

              <div className="space-y-3 sm:space-y-4">
                {[
                  '広告判断が感覚',
                  '予約数が月でブレる',
                  '改善点が不明',
                  '院長が毎回考える'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-circle-line text-lg text-gray-400"></i>
                    </div>
                    <p className="text-sm sm:text-base text-gray-700">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 sm:p-8 shadow-lg border-2 border-[#1A3A52]">
              <h3 className="text-xl sm:text-2xl font-bold text-[#1A3A52] text-center mb-5 sm:mb-6">After</h3>
              
              {/* After画像追加 */}
              <div className="mb-5">
                <img 
                  src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/c87c891868f838f0ae9562f6d99bb394.webp"
                  alt="改善後のサイト"
                  className="w-full h-auto rounded-xl shadow-md"
                />
                <p className="text-xs text-gray-600 text-center mt-2">迷わず問い合わせへ進める</p>
              </div>

              <div className="space-y-3 sm:space-y-4">
                {[
                  '月間予約の予測が立つ',
                  '利益増減の理由が分かる',
                  '改善が再現できる',
                  '集客が"確認作業"になる'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-circle-line text-lg text-[#1A3A52]"></i>
                    </div>
                    <p className="text-sm sm:text-base text-gray-900 font-medium">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 提供内容 */}
      <section id="service" className="py-12 sm:py-16 lg:py-20 bg-[#F0F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">提供内容</h2>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10">
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-[#1A3A52] mb-4 sm:mb-5">含まれること</h3>
              <div className="space-y-3">
                {[
                  '利益構造の分析',
                  'LP・コピーの再設計',
                  '広告設計（検索意図ベース）',
                  '予約・LINE統合設計',
                  '改善サイクル構築'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-lg text-[#1A3A52]"></i>
                    </div>
                    <p className="text-sm sm:text-base text-gray-800 font-medium">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5">やらないこと</h3>
              <div className="space-y-3">
                {[
                  '無意味な広告費増額',
                  'ブラックボックス運用',
                  'ツール押し売り'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-2.5">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-lg text-gray-400"></i>
                    </div>
                    <p className="text-sm sm:text-base text-gray-600">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 価格 */}
      <section id="price" className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-10 lg:mb-12">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">月3〜5名増で回収可能な設計</h2>
            <p className="text-sm sm:text-base text-gray-600">― 利益視点の料金プラン ―</p>
          </div>
          
          {/* プラン比較 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-10 sm:mb-12">
            {/* ライトプラン */}
            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-lg border border-gray-200">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">ライトプラン</h3>
              <p className="text-sm text-gray-600 mb-5 sm:mb-6">まずは原因を把握したい方向け</p>
              
              <div className="mb-5 sm:mb-6">
                <div className="mb-3">
                  <p className="text-xs text-gray-600 mb-1">初期費用</p>
                  <p className="text-2xl sm:text-3xl font-bold text-gray-900">¥98,000<span className="text-sm text-gray-600">（税込）</span></p>
                </div>
                <div className="mb-3">
                  <p className="text-xs text-gray-600 mb-1">月額費用</p>
                  <p className="text-2xl sm:text-3xl font-bold text-gray-900">¥49,000<span className="text-sm text-gray-600">（税込）</span></p>
                </div>
                <div>
                  <p className="text-xs text-gray-600 mb-1">最低契約</p>
                  <p className="text-base sm:text-lg font-bold text-gray-900">3ヶ月</p>
                </div>
              </div>

              <div className="bg-[#E8F5F1] rounded-lg p-4 mb-5 sm:mb-6">
                <h4 className="text-sm font-bold text-gray-900 mb-2">想定改善幅</h4>
                <p className="text-lg sm:text-xl font-bold text-[#1A3A52]">月3名増で回収ライン到達</p>
              </div>

              <div className="mb-5 sm:mb-6">
                <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-3">できること</h4>
                <div className="space-y-2">
                  {[
                    '既存LPの構成・コピー改善',
                    '計測・導線の整理',
                    '最低限の広告改善',
                    '改善ポイントと優先順位の明確化'
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-base text-[#1A3A52]"></i>
                      </div>
                      <p className="text-xs sm:text-sm text-gray-700">{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <a 
                href="#contact" 
                className="block w-full px-4 py-3 bg-white text-[#1A3A52] text-center text-sm font-bold rounded-lg border-2 border-[#1A3A52] hover:bg-[#F0F7F4] transition-all whitespace-nowrap cursor-pointer"
              >
                まずはライトで相談する
              </a>
            </div>

            {/* スタンダードプラン */}
            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-xl border-2 border-[#1A3A52] relative">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#1A3A52] text-white px-4 py-1.5 rounded-full text-xs font-bold whitespace-nowrap">おすすめ</span>
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-[#1A3A52] mb-2">スタンダードプラン</h3>
              <p className="text-sm text-gray-600 mb-5 sm:mb-6">利益を仕組み化したい方向け</p>
              
              <div className="mb-5 sm:mb-6">
                <div className="mb-3">
                  <p className="text-xs text-gray-600 mb-1">初期費用</p>
                  <p className="text-2xl sm:text-3xl font-bold text-[#1A3A52]">¥198,000<span className="text-sm text-gray-600">（税込）</span></p>
                </div>
                <div className="mb-3">
                  <p className="text-xs text-gray-600 mb-1">月額費用</p>
                  <p className="text-2xl sm:text-3xl font-bold text-[#1A3A52]">¥98,000<span className="text-sm text-gray-600">（税込）</span></p>
                </div>
                <div>
                  <p className="text-xs text-gray-600 mb-1">最低契約</p>
                  <p className="text-base sm:text-lg font-bold text-[#1A3A52]">3ヶ月</p>
                </div>
              </div>

              <div className="bg-[#E8F5F1] rounded-lg p-4 mb-5 sm:mb-6 border-2 border-[#1A3A52]">
                <h4 className="text-sm font-bold text-gray-900 mb-3">想定改善幅</h4>
                <div className="space-y-1.5">
                  <p className="text-base sm:text-lg font-bold text-[#1A3A52]">月5名増で黒字化</p>
                  <p className="text-base sm:text-lg font-bold text-[#1A3A52]">月8名増で利益30万円超</p>
                </div>
              </div>

              <div className="mb-5 sm:mb-6">
                <h4 className="text-sm sm:text-base font-bold text-gray-900 mb-3">できること</h4>
                <div className="space-y-2">
                  {[
                    'LP構成・コピーの再設計',
                    '計測・広告・予約導線の統合',
                    '改善サイクルの設計と実行',
                    '判断基準の言語化'
                  ].map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-sm text-[#1A3A52]"></i>
                      </div>
                      <p className="text-xs sm:text-sm text-gray-700 font-medium">{item}</p>
                    </div>
                  ))}
                </div>
              </div>

              <a 
                href="#contact" 
                className="block w-full px-4 py-3 bg-[#1A3A52] text-white text-center text-sm font-bold rounded-lg hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                最初からスタンダードで進める
              </a>
            </div>
          </div>

          {/* 共通注記 */}
          <div className="text-center mb-10 sm:mb-12">
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              ※ 広告費別途（月5万円〜）
            </p>
          </div>

          {/* なぜこの価格か */}
          <div className="max-w-3xl mx-auto">
            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-lg border border-gray-200">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-5 sm:mb-6 text-center">なぜ、この価格なのか？</h3>
              
              <div className="space-y-4 sm:space-y-5 mb-5 sm:mb-6">
                <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                  フルリニューアルや<br />
                  広告丸投げ型サービスではありません。
                </p>
                
                <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                  <strong>「今ある資産を活用する」</strong><br />
                  ことに特化しているため、
                </p>

                <div className="bg-[#F0F7F4] rounded-lg p-4">
                  <div className="space-y-2">
                    {[
                      'フル制作ではない',
                      '今ある資産を活用する',
                      '最短で改善判断を可能にする'
                    ].map((item, index) => (
                      <div key={index} className="flex items-start gap-2">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-base text-[#1A3A52]"></i>
                        </div>
                        <p className="text-sm sm:text-base text-gray-800 font-medium">{item}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                  だから<br />
                  <strong className="text-[#1A3A52]">制作会社より安く<br />広告代理店より透明です。</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 安心材料 */}
      <section className="py-12 sm:py-16 lg:py-20 bg-[#F0F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">安心して相談してもらうために</h2>
          
          {/* 信頼画像追加 */}
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/2815b91edac589bb25be5fc410d8b7ea.webp"
              alt="安心して依頼できる"
              className="w-full h-auto rounded-2xl shadow-lg max-w-3xl mx-auto"
            />
            <p className="text-xs sm:text-sm text-gray-600 text-center mt-3">秘密保持と情報管理を前提に進めます</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {[
              { icon: 'ri-time-line', text: '即決不要' },
              { icon: 'ri-hand-heart-line', text: '無理な営業なし' },
              { icon: 'ri-message-3-line', text: '今やるべきでない場合は正直に伝えます' },
              { icon: 'ri-shield-check-line', text: '秘密保持前提' }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-4 sm:p-5 shadow-sm flex items-start gap-3">
                <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-2xl sm:text-3xl text-[#1A3A52]`}></i>
                </div>
                <p className="text-sm sm:text-base text-gray-800 leading-relaxed pt-1">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-10 lg:mb-12">よくある質問</h2>
          
          <div className="space-y-3">
            {[
              {
                q: '小規模でも可能？',
                a: '可能です。むしろ小規模ほど効果が出やすいです。'
              },
              {
                q: '今の広告は止める？',
                a: '止めません。活かせるものは使います。'
              },
              {
                q: '自分で運用できる？',
                a: 'できる状態を目指します。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-4 sm:px-5 py-4 sm:py-5 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="text-sm sm:text-base font-bold text-gray-900 text-left">{faq.q}</span>
                  <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-xl text-[#1A3A52] flex-shrink-0 ml-3`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-4 sm:px-5 pb-4 sm:pb-5">
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 最終CTA */}
      <section id="contact" className="py-12 sm:py-16 lg:py-20 bg-[#E8EDF2]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center text-gray-900 mb-4 sm:mb-6">まずは<br />利益改善シミュレーション（無料）</h2>
          <p className="text-base sm:text-lg text-gray-700 text-center leading-relaxed mb-8 sm:mb-10">
            入力2分<br />
            営業目的の電話はしません。
          </p>

          {/* フォーム直前画像追加 */}
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/4daf73456fd7693f5bf663424882ce34.webp"
              alt="簡単3ステップ"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
            <p className="text-xs sm:text-sm text-gray-600 text-center mt-3">入力は2分。営業目的の電話はしません。</p>
          </div>
          
          <form 
            id="contact-form"
            data-readdy-form
            action="https://readdy.ai/api/form/d65geqn0ioc4omtkab6g" 
            method="POST"
            className="bg-white rounded-2xl p-6 sm:p-8 lg:p-10 shadow-xl"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              
              const requiredFields = ['company_name', 'contact_name', 'email', 'phone', 'business_type', 'concerns'];
              let isValid = true;
              
              requiredFields.forEach(field => {
                const value = formData.get(field);
                if (!value || (typeof value === 'string' && value.trim() === '')) {
                  isValid = false;
                }
              });

              const concerns = formData.get('concerns') as string;
              if (concerns && concerns.length > 500) {
                alert('困りごとは500文字以内で入力してください。');
                return;
              }
              
              if (!isValid) {
                alert('必須項目をすべて入力してください。');
                return;
              }

              // フォームデータをURLエンコード形式に変換
              const formBody = new URLSearchParams();
              formData.forEach((value, key) => {
                formBody.append(key, value.toString());
              });

              fetch(form.action, {
                method: 'POST',
                body: formBody,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              })
                .then(response => {
                  if (response.ok) {
                    form.reset();
                    navigate('/thanks');
                  } else {
                    alert('送信に失敗しました。もう一度お試しください。');
                  }
                })
                .catch(() => {
                  alert('送信に失敗しました。もう一度お試しください。');
                });
            }}
          >
            <div className="space-y-4 sm:space-y-5">
              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">会社名/店舗名 <span className="text-red-500">*</span></label>
                <input 
                  type="text" 
                  name="company_name"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="例：〇〇整体院"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">担当者名 <span className="text-red-500">*</span></label>
                <input 
                  type="text" 
                  name="contact_name"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="例：山田太郎"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">メールアドレス <span className="text-red-500">*</span></label>
                <input 
                  type="email" 
                  name="email"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="example@example.com"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">電話番号 <span className="text-red-500">*</span></label>
                <input 
                  type="tel" 
                  name="phone"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="例：03-1234-5678"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">ウェブサイトURL</label>
                <input 
                  type="url" 
                  name="website_url"
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="https://example.com"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">業種 <span className="text-red-500">*</span></label>
                <select 
                  name="business_type"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base cursor-pointer"
                >
                  <option value="">選択してください</option>
                  <option value="整体">整体</option>
                  <option value="整骨院">整骨院</option>
                  <option value="ジム">ジム</option>
                  <option value="その他">その他</option>
                </select>
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">月商目安（任意）</label>
                <input 
                  type="text" 
                  name="monthly_revenue"
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="例：300万円"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">困りごと <span className="text-red-500">*</span></label>
                <textarea 
                  name="concerns"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base resize-none"
                  placeholder="現在の課題や困っていることをお聞かせください（500文字以内）"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">※500文字以内で入力してください</p>
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-bold text-gray-900 mb-1.5">希望開始時期</label>
                <input 
                  type="text" 
                  name="start_timing"
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1A3A52] text-sm sm:text-base"
                  placeholder="例：1ヶ月以内、3ヶ月以内など"
                />
              </div>

              <button 
                type="submit"
                className="w-full px-6 py-3.5 sm:py-4 bg-[#1A3A52] text-white text-base sm:text-lg font-bold rounded-lg hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                無料で相談する
              </button>

              <p className="text-xs text-gray-500 text-center">
                （所要30分・オンライン）
              </p>
            </div>
          </form>

          <div className="mt-8 sm:mt-10 text-center">
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              ※ 本サービスは成果を保証するものではありません<br />
              ※ ただし「改善できる状態」は必ず作ります
            </p>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-[#1A3A52] py-10 sm:py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-4 sm:mb-6">
            <a 
              href="https://superspoon.net/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white text-sm sm:text-base font-medium mb-1 inline-flex items-center gap-2 hover:text-white/80 transition-colors cursor-pointer"
            >
              <span>運営:Superspoon</span>
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>
          <div className="text-center mb-3 sm:mb-4">
            <a 
              href="/privacy" 
              className="text-white/80 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
            >
              プライバシーポリシー
            </a>
          </div>
          <div className="text-center">
            <p className="text-white/60 text-xs">© 2025 SuperSpoon. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
